import { render, staticRenderFns } from "./StockPageBase.vue?vue&type=template&id=c602d908&scoped=true&"
import script from "./StockPageBase.vue?vue&type=script&lang=js&"
export * from "./StockPageBase.vue?vue&type=script&lang=js&"
import style0 from "./StockPageBase.vue?vue&type=style&index=0&id=c602d908&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c602d908",
  null
  
)

export default component.exports